import _ from 'lodash';

import './style.styl';

angular
  .module(__filename, [
    require('local_modules/filters/dropoff_window').default.name,
    require('local_modules/filters/format_status').default.name,
    require('local_modules/filters/display_order_unit').default.name,
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('public.confirm', {
        url: '/confirm/:hash',
        template: require('./template'),
        controller: require('./controller').default,
        bypassAuth: true,
        resolve: {
          orderData: ngInject(function(OrderSummaryEmail, $stateParams, $state) {
            const onSuccess = (orderData) => orderData;

            const onFailure = function(error) {
              // if the server returns anything other than a 300 it means that we could not resolve an order summary email or a purchase order.
              if (error.status !== 300) {
                $state.go('public.whoops');
                return;
              }
              // if there are no active links for the given hash then inactiveLink will be set
              // if there is a newer active link then newHash will also be set. this will allow the UI to present a confirm all button.
              return {
                purchaseOrder: error.data != null ? error.data.purchaseOrder : undefined,
                lineItems: error.data != null ? error.data.lineItems : undefined,
                catalogItems: error.data != null ? error.data.catalogItems : undefined,
                inactiveLink: error.data != null ? error.data.inactiveLink : undefined,
                newHash: error.data != null ? error.data.newHash : undefined,
                vendor: error.data != null ? error.data.vendor : undefined,
              };
            };

            return OrderSummaryEmail.confirm({hash: $stateParams.hash}).$promise.then(
              onSuccess,
              onFailure,
            );
          }),

          newHash: ngInject((orderData) => orderData.newHash),
          inactiveLink: ngInject((orderData) => orderData.inactiveLink),
          vendor: ngInject((orderData) => orderData.vendor),
          purchaseOrder: ngInject((orderData) => orderData.purchaseOrder),
          lineItems: ngInject((orderData) => orderData.lineItems),
          catalogItems: ngInject((orderData) =>
            orderData.catalogItems.concat({_id: null, name: 'Delivery Charge'}),
          ),
          catalogItemsById: ngInject((catalogItems) => _.keyBy(catalogItems, ({_id}) => _id)),
        },
      }),
    ),
  );

export default __filename;
